import React, { useState, useRef, useEffect } from 'react'

//third party lib
import SimpleReactValidator from 'simple-react-validator';
import { useNavigate, Link } from "react-router-dom";
import ReactLoading from 'react-loading';
import { useSelector, useDispatch } from 'react-redux'
//service
import { registerUser } from '../service/userService';

//component
import PageUrlGuid from '../component/pageUrlGuid';
import Footer from '../component/footer';
import Header from '../component/header';
import Seperator from '../component/seperator';
// utils
import { successMessage, errorMessage } from "../utils/toastMessage"
//redux
import { changeState } from '../redux/loading';


const Register = () => {
    //=========================================================== use hooks 
    const [getUserName, setUserName] = useState("");
    const [getEmail, setEmail] = useState("");
    const [getPassword, setPassword] = useState("");
    const [getName, setName] = useState("");
    const [getNationalCode, setNationalCode] = useState("");
    const [getPhoneNumber, setPhoneNumber] = useState("");
    const [getRepeatPassword, setRepeatPassword] = useState("");
    const [, setForceUpdate] = useState()
    const [getIsLoading, setIsLoading] = useState(false)

    const navigate = useNavigate();

    //=========================================================== use ref 
    const validator = useRef(
        new SimpleReactValidator({
            messages: {
                required: "پر کردن این ورودی الزامی میباشد",
                min: "حداقل 5 کاراکتر باید وارد کنید",
                max: "حداکثر 20 کاراکتر باید وارد کنید",
                email: "ایمیل نوشته شده صحیح نمی باشد",
                alpha_num: "این فیلد باید شامل حروف و اعداد باشد",
                in: "تکرار رمز عبور با رمز عبور مطابقت ندارد"
            },
            element: (message) => <span>{message}</span>,
        })
    );
    //=========================================================== backend function
    const handleRegister = async (e) => {
        e.preventDefault();
        const user = {
            username: getUserName,
            password: getPassword,
            email: getEmail,
        }

        try {

            if (validator.current.allValid()) {
                setIsLoading(true)
                const { status, data } = await registerUser(user);
                if (status === 201) {
                    successMessage("ثبت نام انجام شد")
                    navigate("/");
                }
            } else {
                validator.current.showMessages();
                setForceUpdate(1)
            }
        } catch (ex) {
            setIsLoading(false)
            if (ex.response.status === 409) {
                if (ex.response.data.message == "user is exists") {
                    errorMessage("نام کاربری از قبل وجود دارد")
                }
                else if (ex.response.data.message == "email is exists") {
                    errorMessage(" ایمیل از قبل وجود دارد")
                }
            }
        }

    }

    //=========================================================== frontend function
    const handleAnimationForInputLabelsFocus = (index) => {
        document.querySelectorAll("label")[index].style.top = "-15px"
    }
    const handleAnimationForInputLabelsBlur = (e, index) => {
        if (e.target.value.length == 0) {
            document.querySelectorAll("label")[index].style.top = "0px"
        }
    }
    //=========================================================== use effect
    return (
        <>
            <PageUrlGuid>
                <Link to={"/"}>
                    صفحه اصلی
                </Link>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <h1>
                    ثبت نام
                </h1>
            </PageUrlGuid>
            <div className='register'>
                <h3>عضویت در سایت</h3>
                <form action="" onSubmit={(e) => handleRegister(e)}>
                    <div className='input-group'>
                        <label
                            htmlFor="userName"
                        >
                            نام کاربری
                        </label>
                        <input
                            autoComplete="off"
                            id='userName' type="text"
                            onChange={(e) => {
                                setUserName(e.target.value);
                                validator.current.showMessageFor(
                                    "userName"
                                );
                            }}
                            value={getUserName}
                            onBlur={(e) => {
                                handleAnimationForInputLabelsBlur(e, 0)
                            }}
                            onFocus={() => {
                                handleAnimationForInputLabelsFocus(0)
                            }} />

                        {validator.current.message(
                            "userName",
                            getUserName,
                            "required|min:5|alpha_num|max:20"
                        )}
                        <i className='fa fa-user'></i>
                    </div>

                    <div className='input-group'>
                        <label
                            htmlFor="email"
                        >
                            ایمیل
                        </label>
                        <input
                            autoComplete="off"
                            id='email' type="text"
                            onChange={(e) => {
                                setEmail(e.target.value);
                                validator.current.showMessageFor(
                                    "email"
                                );
                            }}
                            value={getEmail}
                            onBlur={(e) => {
                                handleAnimationForInputLabelsBlur(e, 1)
                            }}
                            onFocus={() => {
                                handleAnimationForInputLabelsFocus(1)
                            }} />

                        {validator.current.message(
                            "email",
                            getEmail,
                            "required"
                        )}
                        <i className='fa fa-envelope'></i>
                    </div>









                    <div className='input-group'>
                        <label
                            htmlFor="password"
                        >
                            رمز عبور
                        </label>
                        <input
                            autoComplete="off"
                            id='password' type="password"
                            onChange={(e) => {
                                setPassword(e.target.value);
                                validator.current.showMessageFor(
                                    "password"
                                );
                            }}
                            value={getPassword}
                            onBlur={(e) => {
                                handleAnimationForInputLabelsBlur(e, 2)
                            }}
                            onFocus={() => {
                                handleAnimationForInputLabelsFocus(2)
                            }} />

                        {validator.current.message(
                            "password",
                            getPassword,
                            "required|min:5|alpha_num|max:20"
                        )}
                        <i className='fa fa-lock'></i>
                    </div>



                    <div className='input-group'>
                        <label
                            htmlFor="repeatPassword"
                        >
                            تکرار رمز عبور
                        </label>
                        <input
                            autoComplete="off"
                            className='a-fs-10'
                            id='repeatPassword' type="password"
                            onChange={(e) => {
                                setRepeatPassword(e.target.value);
                                validator.current.showMessageFor(
                                    "repeatPassword"
                                );
                            }}
                            value={getRepeatPassword}
                            onBlur={(e) => {
                                handleAnimationForInputLabelsBlur(e, 3)
                            }}
                            onFocus={() => {
                                handleAnimationForInputLabelsFocus(3)
                            }} />

                        {validator.current.message(
                            "repeatPassword",
                            getRepeatPassword,
                            `required|in:${getPassword}`
                        )}
                        <i className='fa fa-lock'></i>
                    </div>

                    {
                        getIsLoading ?
                            <div className='spin-loading'>
                                <ReactLoading type={'spin'} color={'#4387e6'} height={30} width={30} />
                            </div>
                            :
                            <button type='submit'>ثبت نام</button>
                    }




                </form>
                <div className='register-forget'>
                    <Link to="/login">حساب کاربری دارم</Link>
                </div>
            </div>
        </>
    )
}



export default Register